var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoadPaymentPoint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_2)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z",
    fill: "#8484FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4707 12.1873C29.0879 12.1873 29.5751 12.5446 29.6726 13.1618L30.7771 18.879H23.793L23.7605 18.2618H20.6095L20.5771 18.879H13.6579L14.7624 13.1618C14.8923 12.6745 15.3796 12.1873 15.9643 12.1873H21.0643L20.8369 15.8255H23.7605L23.5331 12.1873H28.4707ZM13.2032 21.2828L11.4815 30.151C11.3516 30.8656 11.9688 31.6127 12.6834 31.6127H19.8299L20.1872 25.5382H24.3127L24.67 31.6127H31.7191C32.4337 31.6127 33.0509 30.8981 32.921 30.151L31.1993 21.2828H23.8904L23.9879 23.1019H20.3497L20.4471 21.2828H13.2032Z",
    fill: "#8484FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 20.0809C9.5 18.7491 10.572 17.6446 11.9363 17.6446H32.5637C33.8955 17.6446 35 18.7166 35 20.0809V23.1019C35 23.7841 34.4478 24.3038 33.7981 24.3038C33.1159 24.3038 32.5962 23.7516 32.5962 23.1019V20.0809H11.9038V23.1019C11.9038 23.7841 11.3516 24.3038 10.7019 24.3038C10.0522 24.3038 9.5 23.7516 9.5 23.1019V20.0809Z",
    fill: "#8484FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadPaymentPoint);
export default __webpack_public_path__ + "static/media/43f5c4b2cfc1c0382d4dd87149cd1d54a2e7f1b5f0.svg";
export { ForwardRef as ReactComponent };